<template>
  <form class="signUp findPasswordStep2" id="signupForm" v-kendo-validator @submit.prevent="onSubmit(authNumber)">
    <fieldset>
      <div class="event_month">{{ pickedData }}</div>
      <input type="button" value="인증번호 전송" class="k-button mg0 mgt10" @click="sendAuth()">
      <label class="k-form-field">
        <input
            type="text"
            class="k-textbox"
            v-model="authNumber"
            maxlength="4"
            validationMessage="인증번호 4자리를 입력해 주세요"
            placeholder="인증번호 4자리 입력"
            autofocus required>
      </label>
      <input type="submit" value="암호 재설정" class="mid_btn orange login_btn mt10">
    </fieldset>
  </form>
</template>

<script>
import ApiConfig from '@/api/api.config'
import ApiUtil from '@/api/api.util'
import EtnersCommonUtil from '@/common/etners.common.util'
import EtnersEncDecUtil from '@/common/etners.encDec.util'

export default {
  name: 'FindPasswordStep2',
  props: [
    'param'
  ],
  data () {
    const publicKey = this.$store.state.encStoreModule.enc.data
    return {
      pwInfo:{
        userId: null,
        email: null,
      },
      authNumber: '',
      publicKey: publicKey,
      resultData: {},
      transferMethod: "email",
    }
  },
  created () {
    const vm = this
    vm.pwInfo.email = vm.param.email
    vm.pwInfo.userId = vm.param.userId
  },

  computed: {
    pickedData () {
      return this.pwInfo.email
    }
  },

  methods: {
    async onSubmit (authNumber) {
      const vm = this
      const validator = vm.kendoValidator

      if(!validator.validate()){
        const errors = validator.errors()
        kendo.alert(errors[0])
      }

      const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/auth/confirmAuthNumber.json`
      const userIdRSA = await EtnersEncDecUtil.encryptRSA(vm.pwInfo.userId, vm.publicKey)
      const param = {
        authNumber: vm.authNumber,
        userId: userIdRSA
      }

      ApiUtil.post(url, param).then(response => {
        if (response.data === undefined || response.data.resultStatus === undefined) {
          kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
          return false
        }
        if (response.data.resultStatus.messageCode !== '2000') {
          kendo.alert(response.data.resultStatus.messageText)
          return false
        }
        vm.resultData = response.data.resultData
        kendo.alert('인증되었습니다.')
        vm.$emit('child', vm.pwInfo)

      })
    },

    async sendAuth () {
      const vm = this
      const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/auth/sendAuthNumber.json`
      const userIdRSA = await EtnersEncDecUtil.encryptRSA(vm.pwInfo.userId, vm.publicKey)
      const param = {
        transferMethod: vm.transferMethod,
        userId: userIdRSA
      }

      ApiUtil.post(url, param).then(response => {
        if (response.data === undefined || response.data.resultStatus === undefined) {
          kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
          return false
        }
        if (response.data.resultStatus.messageCode !== '2000') {
          kendo.alert(response.data.resultStatus.messageText)
          return false
        }
        kendo.alert('인증번호가 전송되었습니다.유효시간은 1분 30초입니다.')
      })
    }
  }

}

</script>
